import { render, staticRenderFns } from "./cdgyxy.vue?vue&type=template&id=517cf4a9&scoped=true&"
import script from "./cdgyxy.vue?vue&type=script&lang=js&"
export * from "./cdgyxy.vue?vue&type=script&lang=js&"
import style0 from "./cdgyxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdgyxy.vue?vue&type=style&index=1&id=517cf4a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517cf4a9",
  null
  
)

export default component.exports